import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'UPD M |||| UPD M records',
      fields: {
        id: 'ID',
      },
    }
  }
}